import { Box } from "@mui/material";
import styled from "styled-components";

export const AppointmentStyled = styled(Box)`
  overflow-y: auto;
  height: calc(100vh - 400px);
  .card {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      > div {
        margin-right: 16px;
      }
    }

    .row2 {
      display: flex;
      gap: 80px;

      > div {
        display: flex;
        flex-direction: column;
      }
    }

    .label {
      font-weight: bold;
      font-size: 14px;
      color: #555;
      margin-bottom: 4px;
    }

    .value {
      font-size: 14px;
      color: #333;
    }
  }
`;
